import type { SearchQueryBody } from "@/types";

/**
 * Query key factory for event queries. Mirrors `datasetQueryKeys` so list
 * reads and any future mutation invalidations stay aligned.
 */
export const eventQueryKeys = {
  all: ["events"] as const,
  lists: () => [...eventQueryKeys.all, "list"] as const,
  list: (orgId: string | undefined, query?: SearchQueryBody) =>
    query
      ? ([...eventQueryKeys.lists(), orgId, query] as const)
      : ([...eventQueryKeys.lists(), orgId] as const),
};
